import { useNavigate, useLocation } from "react-router-dom"
import { ucFirst, update } from "../_utils/helper"
import { useState, useContext, useEffect } from 'react'
import { MyContext } from '../App'
import { Row, Col, message, Form, Input, Button } from "antd"
import axios from "axios"
import { Image } from "../components/Image"
import { BsCheck2Circle } from "react-icons/bs"
const brand = window.location.hostname.includes("boxguard") ? "boxguard" : "fastquote"

export function Login() {

      const { AppData, setUserData } = useContext(MyContext)
      const navigate = useNavigate()
      const location = useLocation()
      const queryParams = new URLSearchParams(location.search)

      const [ loading, setLoading ] = useState(false)
      const [ complete, setComplete ] = useState(false)
      const [ btnText, setBtnText ] = useState('View My Account')

      const loginWithMagicLink = async (policyId) => {
            try {
                  const response = await axios.post(`${AppData.api_base}/my/session`, {
                        type: "magiclink",
                        policy_id: policyId
                  })

                  if (response.data.status !== "success") {
                        message.error(response.data.result || "Whoops. Something went wrong")
                        navigate("/")
                        return
                  }

                  const { policy, token } = response.data.result

                  // Token must be stored before any authenticated CRUD calls
                  sessionStorage.setItem("dasher_token", token)

                  // Increment magiclink login counter (auth-protected)
                  const d = {
                        brand,
                        table: "policies",
                        data: {
                              where: { id: policyId },
                              data: { client_login: Number(policy.client_login || 0) + 1 }
                        }
                  }

                  await update(d, AppData)

                  setUserData({ policy, authenticated: true })
                  message.success(`Successful login: ${ucFirst(policy.first_name)} ${ucFirst(policy.last_name)}`)
                  navigate("/")
            } catch (e) {
                  console.error(e)
                  message.error("Whoops. Something went wrong")
                  navigate("/")
            }
      }

      useEffect(() => {

            if (queryParams.has('m')) {

                  (async () => { await loginWithMagicLink(queryParams.get('m')) })()

            }

            // eslint-disable-next-line
      }, [])

      async function onFinish(values) {

            setLoading(true)
            setBtnText('Please wait')

            let result = await axios({
                  method: 'post',
                  url: `${AppData.api_base}/magiclink/create`,
                  data: { policy: values.policy }
            })

            setLoading(false)

            if (result.data.status === "success") {
                  setComplete(true)
            }

            else {
                  message.error(result.data.result)
                  setBtnText('View My Account')
            }

      }

      return (
            <>
                  <Row justify="center">

                        <Col xs={22} md={8} style={{ textAlign: 'center', marginTop: "150px" }}>

                              <Image
                                    src={AppData.style.logo}
                                    width={175}
                                    alt={`${ucFirst(AppData.brand)} Logo`}
                                    clickable={false}
                                    navigate={{}}
                              />

                              <Row justify="center" style={{ marginTop: '25px', padding: '75px 0 50px 0', background: 'rgba(0,0,0,0.01)' }}>

                                    <Col xs={22} lg={16}>

                                          {!loading && !queryParams.has('m')
                                                ? complete
                                                      ? <>
                                                            <BsCheck2Circle style={{ fontSize: "200%", marginBottom: "15px", color: "green" }} />
                                                            <h2>Check your inbox</h2>
                                                            <p>We've sent you a temporary link that will log you straight in without needing a password.</p>
                                                      </>
                                                      :
                                                      <>
                                                            <h2 style={{ marginBottom: "25px" }}>Enter your policy number</h2>

                                                            <Form
                                                                  name="login"
                                                                  layout="vertical"
                                                                  initialValues={{ remember: true }}
                                                                  onFinish={onFinish}
                                                            >
                                                                  <Form.Item
                                                                        name="policy"
                                                                        rules={[
                                                                              { required: true, message: 'Please enter your policy number' }
                                                                        ]}
                                                                  >
                                                                        <Input style={{ textAlign: "center", fontSize: "120%" }} />
                                                                  </Form.Item>

                                                                  <Form.Item>

                                                                        <Button type="primary" style={{ backgroundColor: AppData.style.color }} htmlType="submit" loading={loading}>
                                                                              {btnText}
                                                                        </Button>

                                                                  </Form.Item>

                                                            </Form>

                                                      </>
                                                : "Please wait ..."}

                                    </Col>

                              </Row>

                        </Col >

                  </Row >

            </>
      )

}
